
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 5.25a.75.75 0 01.75.75v9.19l2.157-2.158a.75.75 0 111.06 1.06L12.53 17.53a.75.75 0 01-1.06 0l-3.438-3.437a.75.75 0 111.06-1.06l2.158 2.156V6a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    